import type { OptionPropType } from '@atlaskit/radio/types';
import type { OptionType } from '@atlaskit/select/types';

import type { FormOptionValue } from './field-values';
import {
	FORM_OPTION_FIELD_TYPES,
	FORM_RANKING_FIELD_TYPES,
	FORM_TEXT_FIELD_TYPES,
	type FormAdfField,
	type FormAttachmentField,
	type FormDateField,
	type FormDateTimeField,
	type FormField,
	FormFieldType,
	type FormLocalTimeField,
	type FormNumberField,
	type FormOptionField,
	type FormRankingField,
	type FormTextField,
} from './index';

export const asFormAdfField = (formField: FormField | undefined): FormAdfField | undefined =>
	formField && formField.type === FormFieldType.RICH_TEXT_PARAGRAPH
		? (formField as FormAdfField)
		: undefined;

export const asFormAttachmentField = (
	formField: FormField | undefined,
): FormAttachmentField | undefined =>
	formField && formField.type === FormFieldType.ATTACHMENT
		? (formField as FormAttachmentField)
		: undefined;

export const asFormDateField = (formField: FormField | undefined): FormDateField | undefined =>
	formField?.type === FormFieldType.DATE ? (formField as FormDateField) : undefined;

export const asFormDateTimeField = (
	formField: FormField | undefined,
): FormDateTimeField | undefined =>
	formField?.type === FormFieldType.DATE_TIME ? (formField as FormDateTimeField) : undefined;

export const asFormLocalTimeField = (
	formField: FormField | undefined,
): FormLocalTimeField | undefined =>
	formField?.type === FormFieldType.LOCAL_TIME ? (formField as FormLocalTimeField) : undefined;

export const asFormNumberField = (formField: FormField | undefined): FormNumberField | undefined =>
	formField && formField.type === FormFieldType.NUMBER ? (formField as FormNumberField) : undefined;

export const asFormOptionField = (formField: FormField | undefined): FormOptionField | undefined =>
	formField && (FORM_OPTION_FIELD_TYPES as readonly FormFieldType[]).includes(formField.type)
		? (formField as FormOptionField)
		: undefined;

export const asFormRankingField = (
	formField: FormField | undefined,
): FormRankingField | undefined =>
	formField && (FORM_RANKING_FIELD_TYPES as readonly FormFieldType[]).includes(formField.type)
		? (formField as FormRankingField)
		: undefined;

export const asFormTextField = (formField: FormField | undefined): FormTextField | undefined =>
	formField && (FORM_TEXT_FIELD_TYPES as readonly FormFieldType[]).includes(formField.type)
		? (formField as FormTextField)
		: undefined;

export const toOptions = (options?: FormOptionValue[]): OptionType[] =>
	options?.map((option) => ({
		label: option.label,
		value: option.id,
		avatar: option?.avatar,
		byline: option?.byline,
	})) ?? [];

export const toRadioOptions = (options?: FormOptionValue[]): OptionPropType[] =>
	options?.map((option) => ({
		label: option.label,
		value: option.id,
	})) ?? [];
